/* Cover My Plate · vanity, mini and small (3x6, 4x7) plate builder extras (loaded from sections/cmp-seo.liquid on those builders).
   1. Move and zoom an uploaded or AI background. The trimmed part shows dimmed past the plate, zooming out fills
      the edges with the photo's edge color, and a soft-print warning shows when the photo is stretched too far.
      Screen, order preview and print file all use the same placement. The order gets a hidden _Background Position note.
   2. The order preview image is a see-through PNG: plate shape only, real holes cut out, no screws, no backdrop.
   cmp-bg-holes.js (drawn-hole check) uses window.CMPAdjust. */
(function () {
  'use strict';
  if (window.CMPAdjust) return;
  var AR = { vanity: 2, mini: 4, small36: 2, small47: 1.75 }, BLEED = 18.75, ZMIN = 0.6, ZMAX = 3;
  var HOLES = { vanity: { xs: [0.2, 0.8], ys: [0.105, 0.895], w: 0.084, h: 0.042 }, mini: { xs: [0.2, 0.8], ys: [0.2], w: 0.084, h: 0.084 },
    small36: { xs: [0.1667, 0.8333], ys: [0.1333], w: 0.0417, h: 0.0833 }, small47: { xs: [0.0848, 0.9152], ys: [0.1563], w: 0.0714, h: 0.0625 } };
  var INCH = { vanity: [12, 6], mini: [12, 3], small36: [6, 3], small47: [7, 4] };
  var API = window.CMPAdjust = { holes: HOLES, ar: AR };

  function css() {
    if (document.getElementById('cmpba-css')) return;
    var s = document.createElement('style'); s.id = 'cmpba-css';
    s.textContent = '.cmpba{position:absolute;left:12px;bottom:12px;z-index:5;display:flex;gap:8px;font:500 14px/1.35 Inter,system-ui,sans-serif}.cmpba[hidden],.cmpba [hidden],.cmpba-p [hidden],.cmpba-p[hidden]{display:none!important}' +
      '.cmpba button{display:inline-flex;align-items:center;gap:8px;min-height:38px;padding:0 14px;border:0;border-radius:999px;background:rgba(17,18,20,.86);color:#fff;font:600 14px/1 Inter,system-ui,sans-serif;cursor:pointer;-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}' +
      '.cmpba svg{width:18px;height:18px;fill:none;stroke:#D7FF1F;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.cmpba .cmpba__done{background:#D7FF1F;color:#111}' +
      '.cmpba-p{display:grid;gap:10px;margin:12px 0;font:500 14px/1.4 Inter,system-ui,sans-serif}.cmpba-p>div{padding:12px 14px;border-radius:12px;background:#17181B;border:1px solid rgba(215,255,31,.35);color:#fff}' +
      '.cmpba__note button{margin-left:8px;border:0;background:none;color:#D7FF1F;font:600 14px/1 Inter,system-ui,sans-serif;text-decoration:underline;cursor:pointer;padding:0}' +
      '.cmpba__bar{display:flex;flex-wrap:wrap;align-items:center;gap:10px 12px}.cmpba__bar label{display:flex;align-items:center;gap:10px;flex:1 1 160px}.cmpba__bar input{flex:1;min-width:110px;accent-color:#D7FF1F}.cmpba__bar b{min-width:44px;font-weight:600}' +
      '.cmpba__bar button{min-height:34px;padding:0 14px;border-radius:999px;border:1px solid rgba(255,255,255,.3);background:none;color:#fff;font:600 13px/1 Inter,system-ui,sans-serif;cursor:pointer}.cmpba__bar .cmpba__done{background:#D7FF1F;border-color:#D7FF1F;color:#111}' +
      '.cmpba__hint{flex-basis:100%;font-size:13px;color:#B9BCC0}.cmpba__soft{flex-basis:100%;font-size:13px;color:#FFD27A}' +
      '.cxc.cmpba-on [data-cxc-canvas]{cursor:move;touch-action:none}' +
      '@media (max-width:600px){.cmpba{left:10px;bottom:10px}.cmpba [data-go]{width:40px;min-height:40px;padding:0;justify-content:center}.cmpba [data-go] span{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}}';
    document.head.appendChild(s);
  }

  function img(c) { var s = c.st; if (s.bg === 'custom' && s.customBg) return s.customBg; if (s.bg === 'ai' && s.ai && s.ai.img) return s.ai.img; return null; }
  function size(i) { return [i.naturalWidth || i.width, i.naturalHeight || i.height]; }
  function isDefault(a) { return !a || (a.z === 1 && a.x === 0 && a.y === 0); }
  function edge(i) {
    if (i._cmpEdge) return i._cmpEdge;
    var col = '#808080';
    try {
      var c = document.createElement('canvas'), w = 64, h = 64, g = c.getContext('2d'); c.width = w; c.height = h; g.drawImage(i, 0, 0, w, h);
      var d = g.getImageData(0, 0, w, h).data, r = 0, gg = 0, b = 0, n = 0;
      for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) { if (x > 1 && x < w - 2 && y > 1 && y < h - 2) continue; var k = (y * w + x) * 4; r += d[k]; gg += d[k + 1]; b += d[k + 2]; n++; }
      col = 'rgb(' + Math.round(r / n) + ',' + Math.round(gg / n) + ',' + Math.round(b / n) + ')';
    } catch (e) {}
    return (i._cmpEdge = col);
  }
  // where the image goes for trim rect T and adjustment a
  function place(i, T, a) {
    var s = size(i), s0 = Math.max(T.w / s[0], T.h / s[1]), k = s0 * (a ? a.z : 1), w = s[0] * k, h = s[1] * k;
    return { x: T.x + T.w * (0.5 + (a ? a.x : 0)) - w / 2, y: T.y + T.h * (0.5 + (a ? a.y : 0)) - h / 2, w: w, h: h, k: k };
  }
  API.place = place; API.img = img;

  function setup(c) {
    if (c._cmpba) return; c._cmpba = 1; css();
    var root = c.root, cv = root.querySelector('[data-cxc-canvas]'), stage = (cv && cv.closest('.cxc__stage')) || (cv && cv.parentNode);
    if (!cv || !stage) return;
    if (getComputedStyle(stage).position === 'static') stage.style.position = 'relative';
    c._adj = { z: 1, x: 0, y: 0 }; c._adjImg = null; c._adjOn = false;

    var mv = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v18M3 12h18M12 3l-3 3M12 3l3 3M12 21l-3-3M12 21l3-3M3 12l3-3M3 12l3 3M21 12l-3-3M21 12l-3 3"/></svg>';
    var ui = document.createElement('div'); ui.className = 'cmpba'; ui.hidden = true;
    ui.innerHTML = '<button type="button" data-go>' + mv + '<span>Move or zoom photo</span></button><button type="button" class="cmpba__done" data-done hidden>Done</button>';
    stage.appendChild(ui);
    var box = document.createElement('div'); box.className = 'cmpba-p';
    box.innerHTML = '<div class="cmpba__note" data-n hidden></div>' +
      '<div class="cmpba__bar" data-bar hidden><label>Zoom <input type="range" min="' + ZMIN * 100 + '" max="' + ZMAX * 100 + '" step="1" value="100" data-z aria-label="Zoom the photo"></label><b data-zv>100%</b>' +
      '<button type="button" data-reset>Reset</button><button type="button" class="cmpba__done" data-done>Done</button>' +
      '<span class="cmpba__hint">Drag the photo to move it. Drag a corner to make it bigger or smaller. The dimmed part won\'t print.</span><span class="cmpba__soft" data-soft hidden>Zoomed this far, the photo may print soft. A bigger image prints sharper.</span></div>';
    var go = ui.querySelector('[data-go]'), done1 = ui.querySelector('[data-done]'), bar = box.querySelector('[data-bar]'), zr = box.querySelector('[data-z]'), zv = box.querySelector('[data-zv]'), soft = box.querySelector('[data-soft]'), note = box.querySelector('[data-n]');
    function seat() {
      var pane = root.querySelector('[data-cxs-pane="bg"]'); if (!pane) return;
      var pn = pane.querySelector('[data-cxc-bgpanel="up"]:not([hidden])') || pane.querySelector('[data-cxc-bgpanel="ai"]:not([hidden])'), mini = pane.querySelector('.cxc__bgmini');
      if (pn) { if (pn.nextSibling !== box) pn.parentNode.insertBefore(box, pn.nextSibling); }
      else if (mini) { if (mini.previousSibling !== box) mini.parentNode.insertBefore(box, mini); }
      else if (box.parentNode !== pane) pane.appendChild(box);
    }
    API.note = function (cc, html) { if (cc !== c) return; note.innerHTML = html || ''; note.hidden = !html; box.hidden = note.hidden && bar.hidden; };

    function trimIn() { return HOLES[c.kind] ? (INCH[c.kind] || [12, 6]) : null; }
    function refresh() {
      var i = img(c), ok = !!i && !!HOLES[c.kind] && (!c.st.view || c.st.view === 'close');
      ui.hidden = !ok; seat();
      if (!ok && c._adjOn) mode(false);
      go.hidden = c._adjOn; done1.hidden = !c._adjOn; bar.hidden = !c._adjOn; box.hidden = note.hidden && bar.hidden;
      var a = c._adj; zr.value = Math.round(a.z * 100); zv.textContent = Math.round(a.z * 100) + '%';
      if (i) { var t = trimIn(), s = size(i), s0 = Math.max(t[0] * 300 / s[0], t[1] * 300 / s[1]); soft.hidden = 300 / (s0 * a.z) >= 150; }
    }
    function mode(on) { c._adjOn = on; root.classList.toggle('cmpba-on', on); if (on) { c.st.sel = null; c._adjN = c.st.layers.length; } else cv.style.cursor = ''; refresh(); c.draw(); }
    // move/zoom is on by default: it opens by itself for every new photo, and closes when they move on to logo or text
    root.addEventListener('click', function (e) {
      if (!c._adjOn) return;
      var t = e.target.closest('[data-cxs-tab], [data-cxs-next], .cxc__quick button');
      if (t && t.getAttribute('data-cxs-tab') !== 'bg') mode(false);
    }, true);
    API.set = function (cc, a, quiet) { if (cc !== c) return; c._adj = { z: Math.max(ZMIN, Math.min(ZMAX, a.z)), x: a.x, y: a.y }; refresh(); c.draw(); if (!quiet && c.sync) c.sync(); };
    API.get = function (cc) { return cc === c ? c._adj : null; };

    go.addEventListener('click', function () { if (c.goTab) c.goTab('bg'); mode(true); });
    done1.addEventListener('click', function () { mode(false); });
    box.querySelector('[data-done]').addEventListener('click', function () { mode(false); });
    box.querySelector('[data-reset]').addEventListener('click', function () { API.set(c, { z: 1, x: 0, y: 0 }); });
    zr.addEventListener('input', function () { var a = c._adj; API.set(c, { z: zr.value / 100, x: a.x, y: a.y }, true); });

    // background drawing: same placement on screen, preview and print
    var pb = c.paintBg;
    c.paintBg = function (g, x, y, w, h) {
      var i = img(this);
      if (!i || !HOLES[this.kind] || isDefault(this._adj)) return pb.apply(this, arguments);
      var T = { x: x, y: y, w: w, h: h };
      if (x === 0 && y === 0 && w === g.canvas.width && h === g.canvas.height && w > 2000) T = { x: BLEED, y: BLEED, w: w - 2 * BLEED, h: h - 2 * BLEED };
      var p = place(i, T, this._adj);
      g.save(); g.beginPath(); g.rect(x, y, w, h); g.clip(); g.fillStyle = edge(i); g.fillRect(x, y, w, h); g.drawImage(i, p.x, p.y, p.w, p.h); g.restore();
    };

    // see-through order preview: plate only, holes cut out, no screws, no backdrop
    c.previewFile = function () {
      var ar = AR[this.kind] || 2, W = 1200, H = Math.round(W / ar), cn = document.createElement('canvas'); cn.width = W; cn.height = H;
      var g = cn.getContext('2d'), sel = this.st.sel; this.st.sel = null;
      try { this.renderProduct(this.kind, g, 0, 0, W, H, { box: true }); } catch (e) {}
      this.st.sel = sel;
      g.globalCompositeOperation = 'destination-in'; g.fillStyle = '#000';
      if (window.CXU && window.CXU.rr) { window.CXU.rr(g, 0, 0, W, H, 0.026 * W); g.fill(); }
      return cn.toDataURL('image/png');
    };

    // the holes are cut with whatever fill color the canvas was left on; after the first draw that is a see-through
    // gradient, so the cut barely removed anything and the holes looked filled in. Start every render on solid black.
    var rp0 = c.renderProduct;
    c.renderProduct = function (k, g) { g.save(); g.fillStyle = '#000'; g.globalAlpha = 1; try { return rp0.apply(this, arguments); } finally { g.restore(); } };

    // see-through holes on screen: the glow layer behind the plate was showing through the cut-outs in plate color,
    // so each hole is backed with the stage backdrop color at that spot (the hole's edge shading stays on top)
    function backdrop(px, py) {
      var st = getComputedStyle(stage).backgroundImage, m = /radial-gradient\(([\d.]+)% ([\d.]+)% at ([\d.]+)% ([\d.]+)%,(.*)\)$/.exec(st);
      var stops = m ? (m[5].match(/rgba?\([^)]+\)\s*[\d.]+(px|%)/g) || []) : [];
      if (stops.length < 2) return '#1a1b1d';
      var sb = stage.getBoundingClientRect(), W = sb.width, H = sb.height;
      var t = Math.min(1, Math.hypot((px - W * m[3] / 100) / (W * m[1] / 100), (py - H * m[4] / 100) / (H * m[2] / 100)));
      var pts = stops.map(function (s) { var n = s.match(/[\d.]+/g); return { c: [+n[0], +n[1], +n[2]], p: /px$/.test(s) ? 0 : +n[n.length - 1] / 100 }; });
      for (var k = 1; k < pts.length; k++) if (t <= pts[k].p || k === pts.length - 1) {
        var a = pts[k - 1], b = pts[k], f = Math.max(0, Math.min(1, (t - a.p) / ((b.p - a.p) || 1)));
        return 'rgb(' + a.c.map(function (v, j) { return Math.round(v + (b.c[j] - v) * f); }).join(',') + ')';
      }
      return '#1a1b1d';
    }
    function seeThrough(r) {
      var H = HOLES[c.kind], g = cv.getContext('2d'), rr = window.CXU && window.CXU.rr; if (!H || !rr) return;
      var cb = cv.getBoundingClientRect(), sb = stage.getBoundingClientRect(), d = r.dpr || 1, hw = H.w * r.w, hh = H.h * r.h;
      H.ys.forEach(function (fy) { H.xs.forEach(function (fx) {
        var x = r.x + fx * r.w, y = r.y + fy * r.h;
        g.save(); g.globalCompositeOperation = 'destination-over';
        rr(g, x - hw / 2, y - hh / 2, hw, hh, hh / 2);
        g.fillStyle = backdrop(cb.left - sb.left + x / d, cb.top - sb.top + y / d); g.fill(); g.restore();
      }); });
    }

    // dimmed overflow while adjusting; watch for a new photo
    var od = c._draw;
    c._draw = function () {
      od.apply(this, arguments);
      var i = img(this);
      if (i !== this._adjImg) {
        this._adjImg = i; this._adj = { z: 1, x: 0, y: 0 }; API.note(this, '');
        if (i && HOLES[this.kind] && window.CMPHoles) { var me = this; setTimeout(function () { window.CMPHoles.check(me, i); }, 60); }
        if (this._adjOn && !i) mode(false);
        if (i && HOLES[this.kind] && (!this.st.view || this.st.view === 'close')) { this._adjOn = true; root.classList.add('cmpba-on'); this.st.sel = null; this._adjN = this.st.layers.length; }
        refresh();
      }
      if (this._adjOn && this.st.layers.length > (this._adjN || 0)) { this._adjOn = false; root.classList.remove('cmpba-on'); refresh();
      }
      if (this.plateRect && (!this.st.view || this.st.view === 'close')) seeThrough(this.plateRect);
      c._adjH = null;
      if (this._adjOn && i && this.plateRect) {
        var r = this.plateRect, g = cv.getContext('2d'), p = place(i, r, this._adj), d = r.dpr || 1, rad = 0.026 * r.w;
        // the part that gets trimmed, dimmed outside the plate (plate outline added as a second sub-path for even-odd)
        g.save(); g.beginPath(); g.rect(0, 0, cv.width, cv.height);
        g.moveTo(r.x + rad, r.y); g.arcTo(r.x + r.w, r.y, r.x + r.w, r.y + r.h, rad); g.arcTo(r.x + r.w, r.y + r.h, r.x, r.y + r.h, rad);
        g.arcTo(r.x, r.y + r.h, r.x, r.y, rad); g.arcTo(r.x, r.y, r.x + r.w, r.y, rad); g.closePath();
        g.clip('evenodd'); g.globalAlpha = 0.32; g.drawImage(i, p.x, p.y, p.w, p.h); g.restore();
        // outline of the whole photo + corner handles to resize (same look as the logo handle), kept on screen
        var m = 14 * d, cw = cv.width, ch = cv.height;
        g.save(); g.lineWidth = 1.5 * d; g.strokeStyle = 'rgba(255,255,255,.85)'; g.strokeRect(p.x, p.y, p.w, p.h); g.restore();
        c._adjH = [[p.x, p.y], [p.x + p.w, p.y], [p.x, p.y + p.h], [p.x + p.w, p.y + p.h]].map(function (q) {
          var hx = Math.max(m, Math.min(cw - m, q[0])), hy = Math.max(m, Math.min(ch - 66 * d, q[1])); // bottom ones stay above the Done button
          g.save(); g.beginPath(); g.arc(hx, hy, 9 * d, 0, 2 * Math.PI); g.fillStyle = '#CFF516'; g.fill(); g.lineWidth = 2 * d; g.strokeStyle = '#0B0C0C'; g.stroke(); g.restore();
          return { x: hx, y: hy };
        });
        c._adjC = { x: p.x + p.w / 2, y: p.y + p.h / 2 };
      }
    };

    // drag, pinch and wheel while adjusting (captured before the layer handlers)
    var pts = {}, last = null;
    function xy(e) { var b = cv.getBoundingClientRect(), d = (c.plateRect && c.plateRect.dpr) || window.devicePixelRatio || 1; return { x: (e.clientX - b.left) * d, y: (e.clientY - b.top) * d }; }
    function stop(e) { e.stopImmediatePropagation(); e.preventDefault(); }
    function span() { var k = Object.keys(pts); if (k.length < 2) return 0; var a = pts[k[0]], b = pts[k[1]]; return Math.hypot(a.x - b.x, a.y - b.y); }
    function onHandle(q) { var d = (c.plateRect && c.plateRect.dpr) || 1, h = c._adjH || []; for (var k = 0; k < h.length; k++) if (Math.hypot(q.x - h[k].x, q.y - h[k].y) <= 18 * d) return k; return -1; }
    var rs = null;
    cv.addEventListener('pointerdown', function (e) {
      if (!c._adjOn) return; stop(e); try { cv.setPointerCapture(e.pointerId); } catch (z) {}
      var q = xy(e), k = onHandle(q);
      if (k > -1 && c._adjC && !Object.keys(pts).length) { rs = { id: e.pointerId, d0: Math.max(1, Math.hypot(q.x - c._adjC.x, q.y - c._adjC.y)), z0: c._adj.z, c: c._adjC }; return; }
      pts[e.pointerId] = q; last = { s: span(), z: c._adj.z };
    }, true);
    cv.addEventListener('pointermove', function (e) {
      if (!c._adjOn) return;
      if (rs && rs.id === e.pointerId) { stop(e); var q0 = xy(e), a0 = c._adj; API.set(c, { z: rs.z0 * Math.hypot(q0.x - rs.c.x, q0.y - rs.c.y) / rs.d0, x: a0.x, y: a0.y }, true); return; }
      if (!pts[e.pointerId]) { var k = onHandle(xy(e)); cv.style.cursor = k < 0 ? '' : (k === 0 || k === 3 ? 'nwse-resize' : 'nesw-resize'); return; }
      stop(e);
      var p = xy(e), q = pts[e.pointerId], r = c.plateRect, a = c._adj; pts[e.pointerId] = p;
      if (!r) return;
      if (Object.keys(pts).length > 1) { var s = span(); if (last && last.s) API.set(c, { z: last.z * s / last.s, x: a.x, y: a.y }, true); return; }
      var lim = 0.5 + a.z / 2;
      API.set(c, { z: a.z, x: Math.max(-lim, Math.min(lim, a.x + (p.x - q.x) / r.w)), y: Math.max(-lim, Math.min(lim, a.y + (p.y - q.y) / r.h)) }, true);
    }, true);
    function up(e) { if (!c._adjOn) return; stop(e); if (rs && rs.id === e.pointerId) { rs = null; if (c.sync) c.sync(); return; } delete pts[e.pointerId]; last = { s: span(), z: c._adj.z }; if (c.sync) c.sync(); }
    cv.addEventListener('pointerup', up, true); cv.addEventListener('pointercancel', up, true);
    ['click', 'mousedown', 'touchstart'].forEach(function (t) { cv.addEventListener(t, function (e) { if (c._adjOn) stop(e); }, { capture: true, passive: false }); });
    cv.addEventListener('wheel', function (e) { if (!c._adjOn) return; stop(e); var a = c._adj; API.set(c, { z: a.z * Math.exp(-e.deltaY * 0.0015), x: a.x, y: a.y }, true); }, { capture: true, passive: false });

    var sy = c.sync; c.sync = function () { var r = sy.apply(this, arguments); try { refresh(); } catch (e) {} return r; };
    refresh(); c.draw();
  }

  // order notes for the graphics team
  API.props = function (c) {
    var o = {}, a = c._adj;
    if (img(c) && !isDefault(a)) {
      var h = a.x > 0 ? 'right ' : 'left ', v = a.y > 0 ? 'down ' : 'up ';
      o['_Background Position'] = 'Zoom ' + Math.round(a.z * 100) + '%, moved ' + h + Math.abs(Math.round(a.x * 100)) + '% and ' + v + Math.abs(Math.round(a.y * 100)) + '% of the plate. Print file already matches.';
    }
    if (c._drawnHoles) o['_Drawn Holes'] = c._drawnHoles;
    return o;
  };
  function wrapCart() {
    var C = window.CMP; if (!C || !C.addItems) return setTimeout(wrapCart, 300);
    if (C.addItems._cmpba) return;
    var prev = C.addItems, f = function (items) {
      try {
        var it = items && items[0], el = document.querySelector('[data-cxc]'), c = el && el._cxc;
        if (c && c._cmpba && it && it.properties && it.properties['_Design HQ']) { var o = API.props(c); for (var k in o) it.properties[k] = o[k]; }
      } catch (e) {}
      return prev.apply(this, arguments);
    };
    for (var k in prev) if (Object.prototype.hasOwnProperty.call(prev, k)) f[k] = prev[k];
    f._cmpba = 1; C.addItems = f;
    setTimeout(wrapCart, 2000); // re-wrap if another script wraps after us
  }

  var n = 0;
  (function wait() {
    var el = document.querySelector('[data-cxc]'), c = el && el._cxc;
    if (c && HOLES[c.kind] && Object.prototype.hasOwnProperty.call(c, 'renderProduct') && Object.prototype.hasOwnProperty.call(c, '_draw')) { setup(c); wrapCart(); return; }
    if (++n < 120) setTimeout(wait, 250);
  })();
})();